module.exports = __webpack_public_path__ + "img/CONFIRMER_RESA_GRILLE_POINTAGE.30dd58df.svg";